/*
 * @Description:外调车账目
 * @Author: WangYuhan
 * @Date: 2022-12-26 16:04:45
 * @LastEditTime: 2023-10-18 15:05:20
 * @LastEditors: WangYuhan
 */
import { getDriverList, getVehicleList } from '@/api/capacity';
import { getRouteListByBid } from '@/api/common';
import { getProjectListByBid } from '@/api/project';
import { getTransferAccounts, accountExportExcel } from '@/api/waybill';

const storeModelName = 'transferAccountsModule';

const state = {
  parameters: [
    {
      style: 'select',
      value: '',
      state: 'corps',
      label: '企业',
      isFixed: true,
      placeholder: '请选择',
      noMatchText: '无匹配企业',
      clearable: true,
      filterable: false,
      param: 'businessId',
    },
    {
      style: 'autocomplete',
      value: '',
      state: 'projects',
      label: '项目名称',
      placeholder: '请选择',
      noMatchText: '无匹配项目',
      clearable: true,
      filterable: true,
      isFixed: true,
      valueType: 'string',
      param: 'projectName',
      path: `${storeModelName}/getProject`,
    },
    {
      style: 'select',
      value: '',
      state: 'routeInfoList',
      label: '线路名称',
      placeholder: '请选择',
      noMatchText: '无匹配线路',
      clearable: true,
      filterable: true,
      param: 'routeInfoId',
      path: `${storeModelName}/getRouteInfoList`,
    },
    {
      style: 'input',
      value: '',
      label: '运单编号',
      placeholder: '请输入',
      clearable: true,
      param: 'waybillNo',
    },
    {
      style: 'select',
      value: '',
      state: 'drivers',
      label: '司机',
      placeholder: '请选择',
      noMatchText: '无匹配司机',
      clearable: true,
      filterable: true,
      param: 'driverInfoId',
      path: `${storeModelName}/getDrivers`,
    },
    {
      style: 'select',
      value: '',
      state: 'vehicles',
      label: '车辆',
      placeholder: '请选择',
      noMatchText: '无匹配车辆',
      clearable: true,
      filterable: true,
      param: 'vehicleInfoId',
      path: `${storeModelName}/getVehicles`,
    },
    {
      style: 'date-picker',
      value: [],
      label: '建单时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      param: 'createTime',
      params: ['createStartTime', 'createEndTime'],
    },
    {
      style: 'date-picker',
      value: [],
      label: '支付时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      param: 'payTime',
      params: ['payStartTime', 'payEndTime'],
    },
    {
      style: 'date-picker',
      value: [],
      label: '开票时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      param: 'invoiceTime',
      params: ['invoiceStartTime', 'invoiceEndTime'],
    },
    {
      style: 'casccader',
      value: [],
      label: '装货地',
      placeholder: '请选择',
      clearable: true,
      filterable: true,
      params: ['sendProvince', 'sendCity', 'sendDistrict'],
    },
    {
      style: 'casccader',
      value: [],
      label: '卸货地',
      placeholder: '请选择',
      clearable: true,
      filterable: true,
      params: ['receiveProvince', 'receiveCity', 'receiveDistrict'],
    },
  ],
  postParams: {
    size: 20,
    page: 1,
  },
  // 导出
  isExport: {
    isShow: true,
    method: 'post',
    url: accountExportExcel,
  },
  corps: [],
  drivers: [],
  vehicles: [],
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '运单信息',
        prop: 'waybill',
        checked: 1,
        width: 180,
        sortable: true,
        slotName: 'sub-domain-waybill',
      },
      {
        label: '运力信息',
        prop: 'capacity',
        checked: 1,
        width: 120,
        sortable: true,
        slotName: 'sub-domain-capacity',
      },
      {
        label: '运输成本(元)',
        prop: 'transportationCost',
        checked: 1,
        width: 140,
        sortable: true,
        slotName: 'sub-domain-transportationCost',
      },
      {
        label: '进项成本(元)',
        prop: 'inputCost',
        checked: 1,
        width: 140,
        sortable: true,
        slotName: 'sub-domain-inputCost',
      },
      {
        label: '进项抵扣(元)',
        prop: 'inputDeduction',
        checked: 1,
        width: 110,
        sortable: true,
        slotName: 'sub-domain-inputDeduction',
      },
      {
        label: '降本金额(元)',
        prop: 'costReduction',
        checked: 1,
        width: 110,
        sortable: true,
        slotName: 'sub-domain-costReduction',
      },
      {
        label: '补贴分油降本(元)',
        prop: 'subsidyOilFreight',
        checked: 1,
        width: 200,
        sortable: true,
        slotName: 'sub-domain-subsidyOilFreight',
      },
      {
        label: '时间',
        prop: 'time',
        checked: 1,
        width: 200,
        sortable: true,
        slotName: 'sub-domain-time',
      },
    ],
    total: 0,
  },
  companyInfo: '', // 当前选中的企业信息
  projectInfo: '', // 当前选中的项目信息
  projects: [],
  routeInfoList: [],
};

const getters = {};

const actions = {
  getList: async context => {
    const params = {};
    context.state.parameters.forEach(item => {
      if (item.style !== 'date-picker' && item.style !== 'casccader' && item.value) {
        if (item.multiple) {
          if (item.value.length > 0) {
            params[item.param] = item.value.toString();
          }
        } else {
          params[item.param] = item.value;
        }
      }
      if (item.style === 'date-picker' && item.value.length > 0) {
        params[item.params[0]] = `${item.value[0]} 00:00:00`;
        params[item.params[1]] = `${item.value[1]} 23:59:59`;
      }
      if (item.style === 'casccader' && item.value.length > 0) {
        params[item.params[0]] = item.value[0] ? `${item.value[0]}` : '';
        params[item.params[1]] = item.value[1] ? `${item.value[1]}` : '';
        params[item.params[2]] = item.value[2] ? `${item.value[2]}` : '';
      }
    });

    var accountsDetailListHabits = {};
    const obj = Object.assign({}, context.state.postParams);
    if (obj.businessId || params.businessId) {
      accountsDetailListHabits.businessId = obj.businessId ? obj.businessId : params.businessId;
    }
    if (obj.projectId) {
      accountsDetailListHabits.projectId = obj.projectId;
    }
    if (obj.routeInfoId) {
      accountsDetailListHabits.routeInfoId = obj.routeInfoId;
    }
    localStorage.setItem('accountsDetailListHabits', JSON.stringify(accountsDetailListHabits));

    const { code, data } = await getTransferAccounts(
      Object.assign(
        {},
        {
          page: context.state.postParams.page,
          size: context.state.postParams.size,
        },
        params,
      ),
    );
    context.commit('updateState', {
      key: 'listData',
      value: Object.assign({}, context.state.listData, data),
    });
    return data.list;
    // if (code === 200) {
    //   context.commit('updateListData', data);
    // }
  },
  getProject: async (context, keyword) => {
    return new Promise(async (resolve, reject) => {
      const { code, data } = await getProjectListByBid({
        businessId: context.state.parameters[0].value,
        keyword,
      });
      if (code === 200) {
        data.list.forEach(item => {
          item.value = item.name;
        });
        context.commit('updateState', {
          key: 'projects',
          value: data.list,
        });
        resolve(data.list);
      } else {
        reject();
      }
    });
  },

  // 获取线路列表
  getRouteInfoList: async (context, keyword) => {
    return new Promise(async (resolve, reject) => {
      const { code, data } = await getRouteListByBid({
        businessId: context.state.parameters[0].value,
        lineType: 'transfer',
        keyword,
      });
      if (code === 200) {
        data.list.forEach(item => {
          item.label = item.orderName;
          item.value = item.id;
        });
        context.commit('updateState', {
          key: 'routeInfoList',
          value: data.list,
        });
        resolve(data.list);
      } else {
        reject();
      }
    });
  },
  getDrivers: async (context, name) => {
    const { code, data } = await getDriverList({
      driverProperty: 'transfer',
      name,
    });
    if (code === 200) {
      data.list.forEach(item => {
        item.label = item.name;
        item.value = item.id;
      });
      context.commit('updateState', {
        key: 'drivers',
        value: data.list,
      });
    }
  },
  getVehicles: async (context, vehicleNo) => {
    const { code, data } = await getVehicleList({
      vehicleProperty: 'transfer',
      vehicleNo,
    });
    if (code === 200) {
      data.list.forEach(item => {
        item.label = item.vehicleNo;
        item.value = item.id;
      });
      context.commit('updateState', {
        key: 'vehicles',
        value: data.list,
      });
    }
  },
};

const mutations = {
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
  // 更新data数据
  updateListData(state, payload) {
    state.listData = Object.assign({}, state.listData, payload);
  },
  updateState(state, { key, value }) {
    state[key] = value;
  },
  // 根据index更新value
  updateValueFromIndex(state, payload) {
    console.log('updateValueFromIndex', payload.value, state.parameters[payload.index].param);
    state.parameters[payload.index].value = payload.value;

    // if (payload.index === 0) {
    //   state.projects = [];
    //   state.routeInfoList = [];
    // }
    switch (state.parameters[payload.index].param) {
      case 'businessId':
        if (payload.from !== 1) {
          localStorage.removeItem('accountsDetailListHabits');
          localStorage.setItem(
            'accountsDetailListHabits',
            JSON.stringify({
              businessId: payload.value,
            }),
          );
        }
        state.postParams.businessId = payload.value;
        state.companyInfo = state.corps.find(item => item.businessId === payload.value);
        if (state.parameters[1].value) {
          state.parameters[1].value = '';
          state.postParams.projectId = '';
        }
        if (state.parameters[2].value) {
          state.parameters[2].value = '';
          state.postParams.routeInfoId = '';
        }
        break;
      case 'projectName':
        state.postParams.projectId = payload.id;
        state.projectInfo = state.projects.find(item => item.id === payload.id);
        if (state.parameters[2].value) {
          state.parameters[2].value = '';
          state.postParams.routeInfoId = '';
        }
        break;
      case 'routeInfoId':
        console.log(state.postParams, payload);
        state.postParams.routeInfoId = payload.value;
        break;
      default:
        break;
    }
  },
  // 重置所有状态
  initFilter(state) {
    state.parameters.forEach(item => {
      if (item.isFixed) {
        return;
      }
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple && item.style !== 'input-multiple') {
          item.value = [];
        } else {
          item.value = '';
        }
      }
      if (item.style === 'date-picker' || item.style === 'casccader') {
        item.value = [];
      }
      if (item.state && item.state !== 'corps') {
        state[item.state] = [];
      }
    });
    state.postParams = {
      page: 1,
      size: 20,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
